"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _image = require("@site/pattern-library-core/image");
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-c9c4qtt"
});

/**
 * IconCard Component.
 *
 * @param {Object} props React props
 * @param {String} props.text Icon Card Text
 * @param {Object} props.icon Icon
 * @param {Boolean} props.invert Invert
 * @param {String} props.partial Theme partial
 * @param {String} props.align LTR | RTL Control
 * @returns {React.ReactElement} IconCard Component
 * @public
 */

function RTBIconCard({
  invert,
  icon,
  text,
  partial,
  align
}) {
  return /*#__PURE__*/_react.default.createElement(Container, {
    className: "rtb-card icon-card",
    "data-partial": partial || (invert ? 'dark1' : ''),
    "data-align": align,
    "data-cy": "icon-card"
  }, icon?.url ? /*#__PURE__*/_react.default.createElement(_image.LazyImage, icon) : null, /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    asType: "title",
    className: "h5",
    text: text
  }));
}
RTBIconCard.propTypes = {
  text: _propTypes.default.string,
  icon: _propTypes.default.shape(_image.imgPropShape),
  partial: _propTypes.default.string,
  invert: _propTypes.default.bool,
  align: _propTypes.default.oneOf(['left', 'right'])
};
var _default = exports.default = RTBIconCard;